export default __webpack_public_path__ + "static/media/Share.849702fc.svg";